import { messages } from "@/shared/i18n";

/**
 * Registration feature error code mappings
 *
 * Maps backend RFC 7807 Problem Details error codes to localized messages.
 */
export const REGISTRATION_ERROR_CODES: Record<string, string> = {
  "User.EmailIsNotUnique": messages.registration.errors.emailNotUnique,
};
